import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VehicleDamageDataView, { VehicleDamageDataViewProps } from "./VehicleDamageDataView";

export interface OwnProps {
  viewProps: VehicleDamageDataViewProps;
}
type Props = OwnProps & Omit<AppModalProps, "children">;

export function VehicleDamageDataViewModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <VehicleDamageDataView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{ viewVariant: ViewVariant.Modal, ...viewProps?.displayProps }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
